import React from 'react';
import './KippyMascot.css';

const KippyMascot = ({ 
  message = "Hi, I'm Kippy! Ready to learn?", 
  showBubble = false, 
  size = 'medium', // Options: 'small' | 'medium' | 'large' | 'smaller'
  fixed = false,   // Set to true for screen-locked position
  className = '',
  onClick
}) => {
  return (
    <div 
      className={`kippy-container ${fixed ? 'kippy-fixed' : ''} kippy-size-${size} ${className}`} 
      onClick={onClick}
    >
      {/* Kippy Animated Character */}
      <div className="kippy-character-wrapper">
        <img
          src="../kippy-head-256.png"
          alt="Kippy the Knolup Mascot"
          className="kippy-img"
        />
      </div>

      {/* Speech Bubble Positioned at Bottom */}
      {showBubble && message && (
        <div className="kippy-speech-bubble">
          <div className="kippy-bubble-arrow" />
          <span>{message}</span>
        </div>
      )}
    </div>
  );
};

export default KippyMascot;